import axios from "axios";
import { buildHeaders } from "./_headers.util";
import { resolveApiBaseUrl } from "@/utils/hostname";

export default {
  create(payload) {
    return axios.post(`${resolveApiBaseUrl()}self/subscriptions`, payload, {
      headers: buildHeaders(),
    });
  },
};
